import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxgetcurrentdate">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrentdate')}
            </Typography>
            <p><strong>{translate('fxgetcurrentdate')}</strong> returns the current date according to the system calendar.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>The number of hours difference between local time and UTC time stamp.</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the returned result format.</td>
                                <td>"YYYY-MM-DD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentDate(7 , "YYYY-MM-DD") returns { FormatDate(new Date(), "yyyy-MM-dd") }</div>
                    <div>2. GetCurrentDate(7 , "YYYY-MM") returns { FormatDate(new Date(), "yyyy-MM") }</div>
                    <div>3. GetCurrentDate(7 , "YYYY") returns { FormatDate(new Date(), "yyyy") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetcurrenttime">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrenttime')}
            </Typography>
            <p><strong>{translate('fxgetcurrenttime')}</strong> returns the current time according to the system calendar.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>The number of hours difference between local time and UTC time stamp.</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the returned result format.</td>
                                <td>"HH:mm:ss"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentTime(7 , "HH:mm:ss") returns { FormatDate(new Date(), "HH:mm:ss") }</div>
                    <div>2. GetCurrentTime(7 , "HH:mm") returns { FormatDate(new Date(), "HH:mm") }</div>
                    <div>3. GetCurrentTime(7 , "HH") returns { FormatDate(new Date(), "HH") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetcurrenttimestamp">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrenttimestamp')}
            </Typography>
            <p><strong>{translate('fxgetcurrenttimestamp')}</strong> returns the current date and time according to the system calendar.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>The number of hours difference between local time and UTC time stamp.</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the returned result format.</td>
                                <td>"YYYY-MM-DD HH:mm:ss"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentTimestamp(7 , "YYYY-MM-DD HH:mm:ss") returns { FormatDate(new Date(), "yyyy-MM-dd HH:mm:ss") }</div>
                    <div>2. GetCurrentTimestamp(7 , "YYYY-MM-DD HH:mm") returns { FormatDate(new Date(), "yyyy-MM-dd HH:mm") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetfilesizeiniytes">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetfilesizeiniytes')}
            </Typography>
            <p><strong>{translate('fxgetfilesizeiniytes')}</strong> returns the size of the file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the file.</td>
                                <td>"/tmp/filename.txt"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetFilesizeInBytes("/tmp/log.txt") returns 13726</div>
                    <div>2. GetFilesizeInBytes("/tmp/sample.pdf") returns 38765</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetnumberoffiles">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetnumberoffiles')}
            </Typography>
            <p><strong>{translate('fxgetnumberoffiles')}</strong> returns the number of files present in the directory.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the directory.</td>
                                <td>"/tmp/directory"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetNumberOfFiles("/tmp/document") returns 3</div>
                    <div>2. GetNumberOfFiles("/tmp/download") returns 0</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetscriptparameter">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetscriptparameter')}
            </Typography>
            <p><strong>{translate('fxgetscriptparameter')}</strong> returns the script parameter passed into the current script from step <strong>{translate('runrobot')}</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>

                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetScriptParameter() returns the script parameter passed into the current script from step <strong>{translate('runrobot')}</strong></div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);